export const environment = {
  production: false,
  apis: {
    lineupproAi: 'https://lineup-pro-ai.fly.dev/',
    // lineupproAi: 'https://lineuppro-ai-latest.onrender.com/',
    lineupUrl: 'https://lineup-pro-api.portwavetech.com.br/'
    // lineupUrl: 'https://lineup-pro-api.fly.dev/'
    //  lineupUrl: 'https://localhost:8080/'
  },
  firebase: {
    apiKey: "AIzaSyCMknpab5OL6gqYcdD6PwrbWT6mlzK-z40",
    authDomain: "port-wavetech.firebaseapp.com",
    projectId: "port-wavetech",
    storageBucket: "port-wavetech.firebasestorage.app",
    messagingSenderId: "301190420434",
    appId: "1:301190420434:web:dcc12410216daa3e0ada0b",
    measurementId: "G-PDYJ25K738",
    vapidKey: "BOjhzkgr9NP0EAPPb8Tlbhh9cTYatOtJEfwI8kOgGvqNxGdDVRu4U6NPT0OPeGodSaPCeDD5hgN2EN5mgKUUDZM"
  },
};
// 